<template>
  <v-card>
    <v-navigation-drawer
        v-model="showDrawer"
        app
        :bottom="!showSideNav"
        :expand-on-hover="showSideNav"
    >

      <v-list-item class="px-2">
        <v-list-item-avatar>

          <v-img v-if="isLoggedIn" :src="getAvatarSrc"></v-img>
          <v-img v-else src="../../assets/reddit.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-title v-if="isLoggedIn">{{getUsername}}</v-list-item-title>
        <v-list-item-title v-else>Redditor</v-list-item-title>

        <v-btn
            icon
            @click="menuCloseClick"
            v-if="!showSideNav"
        >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item>
      <v-list-item link @click="logout" v-if="isLoggedIn">
        <v-list-item-icon>
          <v-icon>mdi-logout-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="loginOnClick" v-else>
        <v-list-item-icon>
          <v-icon>mdi-login-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Login</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list
          nav
          dense
      >
        <v-list-item to="/" link >
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/search" link >
          <v-list-item-icon>
            <v-icon>mdi-image-search</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Search</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/compare">
          <v-list-item-icon>
            <v-icon>mdi-compare</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Compare</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/meme-voting">
          <v-list-item-icon>
            <v-icon>mdi-vote</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Meme Training</v-list-item-title>
        </v-list-item>

        <v-list-group
            no-action
            v-if="isLoggedIn"
            prepend-icon="mdi-image-multiple">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title >Feeds</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/post-feed" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-image-search</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Post Feed</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/repost-feed" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-image-search</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Repost Feed</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item link to="/me/watches">
          <v-list-item-icon>
            <v-icon>mdi-binoculars</v-icon>
          </v-list-item-icon>
          <v-list-item-title>My Watches</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/my-subreddits">
          <v-list-item-icon>
            <v-icon>mdi-stack-exchange</v-icon>
          </v-list-item-icon>
          <v-list-item-title>My Subreddits</v-list-item-title>
        </v-list-item>
        <v-list-group
            no-action
            prepend-icon="mdi-chart-bar">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title >Stats</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/stats/top-reposters" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Top Offenders</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/stats/top-image-reposts" class="pl-10" v-if="isLoggedIn">
            <v-list-item-icon>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Top Image Reposts</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/stats/banned-subs" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Banned Subs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
            no-action
            prepend-icon="mdi-cog"
            v-if="isLoggedIn && isAdmin">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title >Admin</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/stats/top-reposters" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Bot Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/admin/monitored-subs" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Monitored Subs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/stats/top-reposters" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-email</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Send Mod Mail</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/admin/message-templates" class="pl-10">
            <v-list-item-icon>
              <v-icon>mdi-message</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Message Templates</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-group>
      </v-list>

    </v-navigation-drawer>
  </v-card>
</template>

<script>
import {permissionMixin} from "@/util/mixins/permissionsMixin";

export default {
  name: "LeftNav",
  mixins: [permissionMixin],
  props: {
    showDrawer: Boolean
  },
  data: () => ({
    admin:false,
  }),
  methods: {
    logout: function () {
      this.$store.dispatch('logout', this)
      this.$router.push('/login')
    },
    loginOnClick() {
      this.$router.push({name: 'Login', query: {origin: this.$router.currentRoute.name, autoredirect: true}})
    },
    menuCloseClick() {
      this.$emit('closeMenu')
    }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn
    },
    getAvatarSrc: function () {
      return localStorage.getItem('avatar');
    },
    getUsername: function () {
      return this.$store.getters.username;
    },
    showSideNav() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return false
        case 'sm': return false
        case 'md': return true
        case 'lg': return true
        case 'xl': return true
        default: return true
      }
    },

  },
}
</script>

<style scoped>

</style>
